import React from 'react';
import { Routes, Route } from "react-router-dom";
import AdminInvestorRegistrationList from "./admin-investor-registration-list/admin-investor-registration-list";

const AdminInvestorRegistrations = () => {
  return (
    <Routes>
      <Route index element={<AdminInvestorRegistrationList />} />
    </Routes>
  )
}

export default AdminInvestorRegistrations;
